import React from "react";
import { useMemo, useCallback, useRef, useState, useEffect } from "react";
import CygnusGrid from "pages/CygnusGrid/CygnusGrid";

/**
 * This is a default grid component for all reports. Please do not change the settings unless customization is required.
 * @param {*} props 
 * @returns 
 */
export const IntegrationReportGrid = (props) => {
  // const gridRef = useRef(props.gridRef);
  const gridStyle = useMemo(() => ({ height: "100%", width: "100%" }), []);
  const [key, setKey] = useState();
  const rowSelection = useMemo(() => {
    return {
      mode: 'singleRow',
      checkboxes: false,
      enableClickSelection: false,
    };
  }, []);

  useEffect(() => {
    // console.log(integration_grid_props.rowData)
    setKey(props?.rowData?.length ?? 0);
  }, [props.rowData])

  return (
    <div style={gridStyle}>
      <CygnusGrid
        key={key}
        ref={props.gridRef}
        columnDefs={props.colDefs}
        fetchData={async () => {
          // Since this is not paginated, just return everything
          return { records: props.rowData, totalCount: props.rowData.length };
        }}
        dataIdentifier="InternalId"
        rowSelection={rowSelection}
        onLoadingChange={props.setRefreshGrid}
        cachedIsLoading={props.refreshGrid}
        cachedData={props.rowData}
        rowHeight={32}
        setCachedData={props.setRowData}
        onSelectionChange={props.onSelectionChanged}     
      />
      
    </div>
  );
};

export const ReportModalGrid = (props) => {
  console.log("REPORT MODAL GRID PROPS: ", props)
  
  const gridStyle = useMemo(() => ({ height: "89.3vh", width: "100%" }), []);
  const [key, setKey] = useState();
  const gridRef = useRef(null);

  useEffect(() => {
    setKey(props?.rowData?.length ?? 0);
  }, [props.rowData])

   useEffect(() => {
    if (props.onRefReady) {
      setInterval(console.log("HELLLO 112", gridRef), 1000)
      setTimeout(props.onRefReady(gridRef), 1000);
    }
  }, [props.onRefReady]);

  const rowSelection = useMemo(() => {
    return {
      mode: 'multiRow',
      enableSelectionWithoutKeys: true,
    };
  }, []);

  return ( 
    <div style={gridStyle}>
      <p className="report-modal-grid-message" >*Note: Retry only works if data is incorrect in the data consuming vendor (assuming you have fixed it). 
        If data was incorrectly uploaded in excel, please upload it again with correct data.</p>      
      <CygnusGrid
        key={key}
        ref={gridRef}
        gRef={gridRef}
        columnDefs={props.colDefs}
        fetchData={async () => {
          // Since this is not paginated, just return everything
          return { records: props.rowData, totalCount: props.rowData.length };
        }}
        dataIdentifier="FlowOrchestratorInstanceLogId"
        rowSelection={rowSelection}
        onLoadingChange={props.setReportIsLoading}
        cachedIsLoading={props.reportIsLoading}
        cachedData={props.rowData}
        rowHeight={25}
        setCachedData={props.setRowData}   
      />
    </div>
  );
};